import _ from 'lodash';
import { PartialDeep } from 'type-fest';
import { EcommerceProduct } from '../../applications/ECommerceApi';

/**
 * The product model.
 */
const UserModel = (data: PartialDeep<EcommerceProduct>) =>
	_.defaults(data || {}, {
		name: '',
		role_id: '',
		email: ''
	});

export default UserModel;
